import React, { FC } from 'react';
import styled from '@emotion/native';
import Text, {Props as TextProps} from '@components/1-atoms/Text';
import InfoSvg from '@assets/icons/info';
import { Spacer } from '@components/1-atoms';

const Container = styled.View`
  align-self: center;
  justify-content: center;
  flex-direction: row;
  min-width: 100%;
  // width: ${({ mini, theme }: any) => mini? `${theme.columnWidth-2}px` : `${theme.contentWidth}px`};
`;



type Props = TextProps & {
  children: React.ReactNode;
  onPress?: () => void;
  icon?: object;
  bg?: string;
  color?: string;
};


const Info: FC<Props> = ({ onPress, bg, icon, children, ...props }) => {
  return (
    <Container onPress={onPress} {...props}>
        <Text xsmall {...props}>
          <InfoSvg />
          <Spacer w={0.5} />
          {children}
        </Text>
    </Container>
  );
};

export default Info;